/**
 * Collapsible row list: use native `open` on <details> instead of data-open.
 * Runs after theme and syncs/removes data-open so only `open` is used.
 */
(function () {
  function syncOpenAttribute(target) {
    if (target.nodeType !== 1 || target.tagName !== 'DETAILS') return;
    if (!target.classList.contains('collapsible-row-list-item')) return;
    var value = target.getAttribute('data-open');
    if (value === 'true') {
      target.open = true;
      target.removeAttribute('data-open');
    } else if (value === 'false') {
      target.open = false;
      target.removeAttribute('data-open');
    }
  }

  function observeMutations() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-open') {
          syncOpenAttribute(mutation.target);
        }
      });
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-open'],
      subtree: true
    });
  }

  function init() {
    document.querySelectorAll('details.collapsible-row-list-item[data-open]').forEach(syncOpenAttribute);
    observeMutations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
